module.exports = __webpack_public_path__ + "static/media/back4.f0d024b7.png";